package org.lennycodes.gradematewebsite

object Routes {
    val admin = "/admin"
    val login = "/login"
}